import { createContext } from 'react';
import {
  AppConfigService,
  AppVersioningService,
  BaseUrlHttpAdapter,
  ErrorMessageService,
  FeatureFlagService,
  GeminiService,
  GlobalModalsService,
  HttpService,
  IntentManagementService,
  LoadingService,
  LokiService,
  ProcessEngineService,
  TextToPromptService,
  UserService,
  WorkflowService
} from '../services';

function createServiceContext(): ServiceContextType {
  const errorMessageService = new ErrorMessageService();
  const globalModalsService = new GlobalModalsService();
  const userService = new UserService(
    errorMessageService,
    globalModalsService,
    new HttpService([new BaseUrlHttpAdapter('/user')]),
    new HttpService([new BaseUrlHttpAdapter('/roles')])
  );
  const intentService = new IntentManagementService(
    new HttpService([
      new BaseUrlHttpAdapter(IntentManagementService.baseUrl),
      userService
    ])
  );
  const workflowService = new WorkflowService(
    new HttpService([
      new BaseUrlHttpAdapter(WorkflowService.baseUrl),
      userService
    ])
  );

  return {
    appConfigService: new AppConfigService(
      errorMessageService,
      new HttpService([
        new BaseUrlHttpAdapter(AppConfigService.baseUrl),
        userService
      ])
    ),
    avsService: new AppVersioningService(
      errorMessageService,
      new HttpService([
        new BaseUrlHttpAdapter(AppVersioningService.baseUrl),
        userService
      ]),
      intentService
    ),
    errorMessageService,
    featureFlagService: new FeatureFlagService(),
    geminiService: new GeminiService(
      new HttpService([new BaseUrlHttpAdapter(GeminiService.baseUrl)])
    ),
    globalModalsService,
    intentService,
    loadingService: new LoadingService(),
    lokiService: LokiService.create(globalModalsService),
    processEngineService: new ProcessEngineService(
      new HttpService([
        new BaseUrlHttpAdapter(ProcessEngineService.baseUrl),
        userService
      ]),
      new HttpService([
        new BaseUrlHttpAdapter(ProcessEngineService.sandboxBaseUrl)
      ])
    ),
    textToPromptService: new TextToPromptService(
      errorMessageService,
      new HttpService([
        new BaseUrlHttpAdapter(TextToPromptService.baseUrl)
      ]),
      workflowService
    ),
    userService,
    workflowService
  };
}

export const defaultServiceContext = createServiceContext();

export const ServiceContext = createContext(defaultServiceContext);

export interface ServiceContextType {
  appConfigService: AppConfigService;
  avsService: AppVersioningService;
  errorMessageService: ErrorMessageService;
  featureFlagService: FeatureFlagService;
  geminiService: GeminiService;
  globalModalsService: GlobalModalsService;
  intentService: IntentManagementService;
  loadingService: LoadingService;
  lokiService: LokiService;
  processEngineService: ProcessEngineService;
  textToPromptService: TextToPromptService;
  userService: UserService;
  workflowService: WorkflowService;
}
